// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"a69cebd8","5088":"43692a8a","6880":"71de9412","7670":"d3111fff"}[chunkId] + ".chunk.css";
};